// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars20Filled: FC<Webinars20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M17.5 16.513v-12.5h-15v7.5H1v-7.5c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h15c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v11c0 .402-.147.753-.44 1.052a1.433 1.433 0 0 1-1.06.448Zm-10.5-5a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 8.513c0-.834.292-1.542.875-2.125A2.893 2.893 0 0 1 7 5.513c.833 0 1.542.291 2.125.875.583.583.875 1.291.875 2.125 0 .833-.292 1.541-.875 2.125A2.893 2.893 0 0 1 7 11.513Zm-6 6v-1.917c0-.361.087-.688.26-.98.174-.29.414-.534.72-.728a9.115 9.115 0 0 1 2.41-1.032c.856-.229 1.726-.343 2.61-.343.889 0 1.753.114 2.594.343.84.23 1.65.573 2.427 1.032.305.18.545.42.719.72.173.3.26.63.26.988v1.917H1Z" />
        </svg>
    );
};

export default Webinars20Filled;
